import React from 'react';
import PropTypes from 'prop-types';
import { get, throttle } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SocialLink, GoogleMapUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';
import HeaderMenu from './HeaderMenu';
import ContactModal from './ContactModal';

const styles = css`
  .Header {
    height: 50px;
    position: fixed;
    width: 100%;
    background-color: ${colors.white};
    z-index: 50;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10);
    top: 0;
    transition: .5s ease-in-out;
    @media (min-width: 992px) {
      background: rgba(255,255,255,0.95);
      height: 110px;
      box-shadow: none;
    }
  }

  .Header_logoWrapper {
    height: 100%;
    align-items: center;
    @media (min-width: 992px) {
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .Header_logo {
    display: flex;
    align-items: center;
    width: 125px;
    padding: 0 0 0 20px;
    box-sizing: content-box;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
    @media (min-width: 992px) {
      width: 260px;
      padding: 20px 0 0 30px;
    }
  }
  .TopNav {
    display: none;
    @media(min-width: 992px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding:7px 20px 9px 0;
      justify-content: flex-end;
      flex-direction: row;
      align-items: center;
    }
  }
  .TopNav_list {
    padding: 3px 0 3px 0;
    margin: 0;
    list-style: none;
    text-align: right;
  }
  .TopNav_listItem {
    display: inline-block;
    text-align: right;
    a {
      color: ${colors.color1};
      line-height: 16px;
      height: 16px;
      font-size: 13px;
      font-weight: 400;
    }
    img {
      width: 22px;
      display: inline-block;
      margin: 0 5px 0 0;
    }
    .Phone {
      background-color: ${colors.color1};
      padding: 7px 13px 8px 13px;
      font-weight: 600;
      font-size: 14px;
      color: ${colors.white};
      letter-spacing: .5px;
      text-align: center;
      margin: 0 0 0 15px;
    }
  }
  .Header_menuToggle {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    height: 100%;
    background-color: ${colors.color1Darkest};
    border: 0;
    padding: 0 15px;
    color: #FFFFFF;
    text-align: center;
    font-size: 9px;
    letter-spacing: 2.24px;
    font-weight: bold;
    @media (min-width: 992px) {
      display: none;
      right: 0;
      width: 56px;
      height: 70px;
    }
    @media (min-width: 1201px) {
      right: 215px;
    }
  }
  .Header_menuToggleIcon {
    width: 35px;
    height: 21px;
    position: relative;
    margin: 5px auto -2px auto;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer;
  }
  .Header_menuToggleIcon span {
    display: block;
    position: absolute;
    width: 100%;
    background: #FFFFFF;
    border-radius: 2px;
    opacity: 1;
    left: 0;
    height: 2px;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
    @media (min-width: 992px) {
      height: 3px;
      background-color: ${colors.body};
    }
  }
  .Header_menuToggleIcon span:nth-child(1) {
    top: 0px;
  }
  .Header_menuToggleIcon span:nth-child(2),.Header_menuToggleIcon span:nth-child(3) {
    top: 7px;
  }
  .Header_menuToggleIcon span:nth-child(4) {
    top: 14px;
  }
  .Header_menuToggleIcon.open span:nth-child(1) {
    top: 10px;
    width: 0%;
    left: 50%;
  }
  .Header_menuToggleIcon.open span:nth-child(2) {
    transform: rotate(45deg);
  }
  .Header_menuToggleIcon.open span:nth-child(3) {
    transform: rotate(-45deg);
  }
  .Header_menuToggleIcon.open span:nth-child(4) {
    top: 10px;
    width: 0%;
    left: 50%;
  }
.OSC_wrapperMobile{
  font-family: ${typography.SansSerif};
  padding-right: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  .OSC_link{
    height: 100%;
    display: flex;
    align-items: center;
  }
  img{
    height:17px;
    padding: 0px 10px;
  }
}
.ContactModal_triggerButton {
  &:focus {
    outline: none !important;
  }
}
.HeaderIcons {
  padding-right: 65px;
}
.HeaderIcon {
  margin: 0 1px;
}

`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
    this.handleScroll = throttle(this.handleScroll.bind(this), 50);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }
  onScroll(scrolled) {
    this.setState({ scrolled });
  }
  handleScroll() {
    const scrollAmount = window.pageYOffset || document.documentElement.scrollTop;
    if (window.matchMedia('(min-width: 992px)').matches) {
      const scrolled = scrollAmount > 108;
      if (scrolled !== this.state.scrolled) {
        this.onScroll(scrolled);
      }
    }
  }
  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  render() {
    const { builder } = this.props;
    const { menuActive, scrolled } = this.state;
    return (
      <div className={styles}>
        <div className={`Header ${scrolled ? 'HeaderAlt' : ''}`}>
          <div className="TopNav">
            <ul className="TopNav_list">
              <li className="TopNav_listItem Header_social">
                {
                  get(builder, 'socialLinks', []).map(link => (
                    <SocialLink
                      key={link}
                      url={link}
                    />
                  ))
                }
              </li>
              <li className="TopNav_listItem">
                <a href={`tel:${get(builder, 'telephone', '').replace(/[^0-9]/g, '')}`} className="Phone">{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
              </li>
            </ul>
          </div>
          <div className="Header_logoWrapper d-flex">
            <Link className="Header_logo d-none d-lg-flex" name="index">
              <img src="/images/laguna-isles-logo.png" alt={builder.name} />
            </Link>
            <Link className="Header_logo d-lg-none" name="index">
              <img src="/images/laguna-isles-logo.png" alt={builder.name} />
            </Link>
            <div className="HeaderIcons ml-auto d-lg-none d-flex flex-row">
              <a
                className="HeaderIcon DirectionsMap"
                href={GoogleMapUrl(builder)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/map-header.svg" alt="map" />
              </a>
              <a href={`tel:${builder.telephone}`} className="HeaderIcon PhoneIcon">
                <img src="/images/phone-header.svg" alt="phone" />
              </a>
              <ContactModal>
                <span className="HeaderIcon">
                  <img src="/images/email-header.svg" alt="email" className="EmailIcon" />
                </span>
              </ContactModal>
            </div>
          </div>
          <button className="Header_menuToggle" onClick={this.toggleMenu} aria-label="Menu">
            <div className={`Header_menuToggleIcon ${menuActive ? 'open' : ''}`}>
              <span />
              <span />
              <span />
              <span />
            </div>
            MENU
          </button>
          <HeaderMenu isActive={menuActive} toggleMenu={this.toggleMenu} />
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js